// extracted by mini-css-extract-plugin
export default {"section":"SlideContentContainer_section__p76L+","visible":"SlideContentContainer_visible__PMCUG","content":"SlideContentContainer_content__oiK-5"};